import React, { Component } from 'react';

import Loading from './Loading';

import * as constants from '../../config/constants/AppConstants';

import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import * as Actions from '../actions/ActionCenter';

class EB02PrintContent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      Datasets: {},
      loading: true
    };
    this.updateState = this.setState.bind(this);
  }

  loadDatasets = async () => {
    let { id } = this.props;
    let sets = [
      { key: "course_eb_02", filter: [{ field: "id", value: id }] },
      { key: "training_details_enterprise_eb_02_lists", filter: [{ field: 'course_eb_02_id', value: id }] },
      { key: "expenses_eb_02", filter: [{ field: 'course_eb_02_id', value: id }] },
    ];

    await Actions.loadDatasets(this.updateState, sets);

    this.setState({loading: false});
  }

  initialize = async () => { await this.loadDatasets(); }

  componentDidMount = async () => { await this.initialize(); }

  componentDidUpdate = async () => { }

  render = () => {

    const { id } = this.props;

    let { Datasets } = this.state;
    let ds = Datasets;

    let eb = ds?.course_eb_02 || {};
    if (eb[0]) { eb = eb[0]; }
    eb = Object.fromEntries(Object.entries(eb).map(([key, value]) => [key, util.renderText(value)]));

    let training_details_enterprise_eb_02_lists = (ds.training_details_enterprise_eb_02_lists || []).map(exp => Object.fromEntries(Object.entries(exp).map(([key, value]) => [key, util.renderText(value)])));

    let expenses_eb_02 = ds?.expenses_eb_02 || [];
    let expenses = (ds.expenses_eb_02 || []).map(exp => Object.fromEntries(Object.entries(exp).map(([key, value]) => [key, util.renderText(value)])));
    let total_expenses = expenses_eb_02.reduce((sum, expense) => {
      return sum + Number(expense.budget || 0);
    }, 0);

    let totalPersonCount = 0, totalDurationDays = 0, totalTrainingHours = 0; 

    return (
      this.state.loading ? (<Loading></Loading>)
      :
      (
      <div className="print-container">
          <>
            <div className="print-page">

                    <h5 className="text-end">แบบฟอร์ม EB-02 Version 1.2</h5>
                    <h6 className="text-end mb-4">สำนักงานคณะกรรมการนโยบายเขตพัฒนาพิเศษภาคตะวันออก (สกพอ.)</h6>

                    <h4 className="text-center"><b>แบบขออนุมัติจัดอบรมระยะสั้นตามแนวทางอีอีซีโมเดล</b></h4>

                    <div className="form-section">
                        
                        <table className="print-table-border mt-2 mb-2">
                            <tbody>

                                <tr>
                                    <td colSpan="4" style={{width: '50%'}}><b>1. รหัสหลักสูตร (ตามประกาศ สกพอ.)</b></td>
                                    <td colSpan="4">{eb.official_course_code}</td>
                                </tr>

                                <tr>
                                    <td colSpan="4" style={{width: '50%'}}><b>2. ชื่อหลักสูตร</b></td>
                                    <td colSpan="4">{eb.course_eb_01_name}</td>
                                </tr>      

                                <tr>
                                    <td colSpan="4" style={{width: '50%'}}>
                                        <b>3. สถานศึกษาผู้รับผิดชอบหลักสูตร</b><br></br>
                                        {eb.academy_name}
                                    </td>
                                    <td colSpan="4">
                                         <b>4. ชื่อผู้รับผิดชอบหลักสูตร / โทรศัพท์</b><br></br>
                                        {eb.course_responser}

                                        {eb.course_responser_contact && (
                                        <>
                                            {' / '}
                                            {eb.course_responser_contact}
                                        </>
                                        )}
                                    </td>
                                </tr>   

                                <tr>
                                    <td colSpan="4" style={{width: '50%'}}><b>5. อัตราค่าลงทะเบียนตลอดหลักสูตร (บาท/คน)</b></td>
                                    <td colSpan="4">{util.formatNumber(eb.registration_fee)}</td>
                                </tr>   

                                <tr>
                                    <td colSpan="8"><b>6. รายละเอียดการฝึกอบรมที่ขออนุมัติ (ขอได้คราวละมากกว่า 1 รุ่น รวมระยะเวลาไม่เกิน 1 เดือน)</b></td>
                                </tr>  
                                <tr>
                                    <td className="text-14px text-center" style={{width: '5%'}}><b>รุ่นที่</b></td>
                                    <td colSpan="2" className="text-14px text-center" style={{width: '35%'}}><b>สถานประกอบการ</b></td>
                                    <td className="text-14px text-center" style={{width: '10%'}}><b>จำนวน<br></br>(คน)</b></td>
                                    <td className="text-14px text-center" style={{width: '15%'}}><b>ประเภท<br></br>อุตสาหกรรม</b></td>
                                    <td className="text-14px text-center" style={{width: '10%'}}><b>ระยะเวลา<br></br>(วัน)</b></td>
                                    <td className="text-14px text-center" style={{width: '10%'}}><b>อบรม<br></br>(ชั่วโมง)</b></td>
                                    <td className="text-14px text-center" style={{width: '15%'}}><b>วันที่อบรม</b></td>
                                </tr> 

                                {(() => {
                                    const sortedList = [...training_details_enterprise_eb_02_lists].sort((a, b) => {
                                        if (a.model_no !== b.model_no) {
                                            return a.model_no - b.model_no; 
                                        }
                                        return a.seq - b.seq;
                                    });
                                    
                                    let previousModelNo = null;

                                    return sortedList.map(tdel => {
                                        const showModelNo = tdel.model_no !== previousModelNo;
                                        previousModelNo = tdel.model_no;

                                        totalPersonCount += Number(tdel.person_count);
                                        totalDurationDays += Number(tdel.duration_days);
                                        totalTrainingHours += Number(tdel.training_hours);

                                        return (
                                            <tr key={tdel.id}>
                                                <td className="text-center text-14px">
                                                    {showModelNo ? tdel.model_no : ''}
                                                </td>

                                                <td colSpan="2" className="text-14px" style={{fontSize: '0.8rem'}}>{tdel.enterprise_name}</td>

                                                <td className="text-center text-14px">{util.formatNumber(tdel.person_count)}</td>
                                                 
                                                <td className="text-center text-14px"></td>

                                                <td className="text-center text-14px">{tdel.duration_days}</td>

                                                <td className="text-center text-14px">{tdel.training_hours}</td>

                                                <td className="text-center text-14px">
                                                    {(() => {
                                                        let { training_start_date, training_end_date } = tdel;

                                                        if(util.isEmpty(training_end_date)){ 
                                                            training_end_date = training_start_date; 
                                                        }

                                                        training_start_date = util.convertDateToBE(training_start_date);
                                                        training_end_date = util.convertDateToBE(training_end_date);

                                                        const start = util.parseDate(training_start_date);
                                                        const end = util.parseDate(training_end_date);

                                                        return util.displayDateRange(start, end);
                                                    })()}                                                    
                                                </td>
                                            </tr>
                                    );
                                });
                                })()}   

                                <tr>
                                    <td colSpan="3" className="text-end text-14px"><b>รวม</b></td>
                                    <td className="text-center text-14px"><b>{util.formatNumber(totalPersonCount)}</b></td>
                                    <td className="text-center text-14px"></td>
                                    <td className="text-center text-14px"><b>{util.formatNumber(totalDurationDays)}</b></td>
                                    <td className="text-center text-14px"><b>{util.formatNumber(totalTrainingHours)}</b></td>
                                    <td className="text-center text-14px"></td>                                 
                                </tr>

                                <tr>
                                    <td colSpan="4"><b>7. งบประมาณ (โปรดระบุงบประมาณรวมทั้งโครงการ)</b></td>
                                    <td className="text-center text-14px">{} </td>
                                    <td colSpan="3" className="text-center text-14px">{util.printText(util.formatNumber(eb.total_budget_eb_02))} บาท</td>
                                </tr>  

                                <tr>
                                    <td className="text-14px text-center" style={{width: '5%'}}><b>ที่</b></td>
                                    <td colSpan="2" className="text-14px text-center" style={{width: '35%'}}><b>หมวดค่าใช้จ่าย</b></td>
                                    <td colSpan="4" className="text-14px text-center" style={{width: '10%'}}><b>รายละเอียดตัวคูณ</b></td>
                                    <td className="text-14px text-center" style={{width: '15%'}}><b>รวม (บาท)</b></td>
                                </tr>  

                                {expenses.map((exp, index) => (
                                <tr key={exp.id}>
                                    <td className="text-14px text-center">{index + 1}</td>
                                    <td colSpan="2" className="text-14px">{exp.expense_category_name}</td>
                                    <td colSpan="4" className="text-14px">{exp.multiplier_details}</td>
                                    <td className="text-14px text-end">{util.formatNumber(exp.budget)}</td>
                                </tr>
                                ))}   

                                <tr key={`total_expenses`}>
                                    <td colSpan="7" className="text-14px text-end"><b>รวมทั้งสิ้น</b></td>
                                    <td className="text-14px text-end"><b>{util.formatNumber(total_expenses)}</b></td>
                                </tr>                                                                                                    

                            </tbody>
                        </table>
                        
                    </div>

            </div>

            <div className="print-page">

                    <div className="form-section">

                        <table className="print-table-border mt-2 mb-2">
                            <tbody>

                                <tr>
                                    <td colSpan="7" style={{width: '85%'}}><b>8. วงเงินที่ขอรับการสนับสนุนจาก EEC (ไม่เกินร้อยละ 50 ของค่าใช้จ่ายจริง)</b></td>
                                    <td className="text-end">{util.formatNumber(eb.budget_request_to_hdc)}</td>
                                </tr>   

                                <tr>
                                    <td colSpan="7" style={{width: '85%'}}><b>9. คิดเป็นวงเงินค่าใช้จ่ายต่อหัวที่ EEC สนับสนุน (ไม่เกินร้อยละ 50 ของค่าใช้จ่ายจริง)</b></td>
                                    <td className="text-end">{util.formatNumber(eb.budget_support_by_hdc)}</td>
                                </tr>    

                                <tr>
                                    <td colSpan="8"><b>10. ลงนามโดยผู้บริหารสถานศึกษาที่มีอำนาจลงนามผูกพันนิติบุคคลหรือผู้ที่ได้รับมอบอำนาจ</b></td>
                                </tr>   

                                <tr>
                                    <td colSpan="3" style={{width: '40%'}}>
                                        <b>ชื่อ-สกุล (พิมพ์)</b><br></br>
                                        {eb.academy_signer_name}<br></br>
                                        <b className="me-2">ตำแหน่ง</b>{eb.academy_signer_position}<br></br>
                                        <b className="me-2">วันที่</b>{util.convertDateToTextBE(eb.academy_sign_date)}
                                    </td>
                                    <td colSpan="5" className="text-top" style={{width: '60%'}}>
                                        <b>ลายมือชื่อ / ตราประทับ (ถ้ามี)</b>
                                    </td>
                                </tr>       
                                <tr>
                                    <td colSpan="3" style={{width: '40%'}}>
                                        <b>11. สำหรับเจ้าหน้าที่</b>
                                    </td>
                                    <td colSpan="5" className="text-top" style={{width: '60%'}}></td>
                                </tr>    

                                <tr>
                                    <td colSpan="3" style={{width: '40%'}}>
                                        <ul className="checkbox-list mb-0">
                                            <li>
                                                <span>
                                                    {eb.course_checked === '1' ? '✔' : '☐'}
                                                </span>
                                                <span className="ms-2">ตรวจสอบหลักสูตรแล้ว</span>
                                            </li>
                                            <li>
                                                <span>
                                                    {eb.budget_within_criteria === '1' ? '✔' : '☐'}
                                                </span>
                                                <span className="ms-2">งบประมาณเป็นไปตามเกณฑ์</span>
                                            </li> 
                                            <li>
                                                <span>
                                                    {eb.hdc_status === '0' ? '✔' : '☐'}
                                                </span>
                                                <span className="ms-2">เห็นสมควรอนุมัติ</span>
                                            </li>   
                                            <li>
                                                <span>
                                                    {eb.hdc_status === '1' ? '✔' : '☐'}
                                                </span>
                                                <span className="ms-2">ไม่สมควรอนุมัติ เนื่องจาก</span>                                                
                                            </li>
                                            <li>
                                                <span className="ms-4">{eb.hdc_reject_cause && ( <span className="underline-placeholder">{util.printText(eb.hdc_reject_cause)}</span>)}<br></br></span>
                                            </li>                                                                                                                              
                                        </ul>
                                    </td>
                                    <td colSpan="5" style={{ width: '60%', position: 'relative' }}>
                                        <div style={{ position: 'absolute', top: 0 }}>
                                            <b className="me-2">ลายมือชื่อ</b>{eb.office_signer_name}
                                        </div>
                                        <div style={{ position: 'absolute', bottom: 0 }}>
                                            <b className="me-2">วันที่</b>{util.convertDateToTextBE(eb.office_sign_date)}
                                        </div>
                                    </td>
                                </tr>   

                                <tr>
                                    <td colSpan="3" style={{width: '40%', height: '120px', position: 'relative' }}>                                    
                                        <div style={{ position: 'absolute', top: 0 }}>
                                            <b>12. คำสั่งการของผู้มีอำนาจอนุมัติ</b>
                                            <ul className="checkbox-list mb-0" >
                                                <li>
                                                    <span>
                                                        {eb.authorized_status === '0' ? '✔' : '☐'}
                                                    </span>
                                                    <span className="ms-2">อนุมัติ</span>
                                                </li>
                                                <li>
                                                    <span>
                                                        {eb.authorized_status === '1' ? '✔' : '☐'}
                                                    </span>
                                                    <span className="ms-2">ไม่อนุมัติ</span>
                                                </li>                                                                                                                              
                                            </ul>
                                        </div>
                                    </td>
                                    <td colSpan="5" style={{ width: '60%', position: 'relative' }}>
                                        <div style={{ position: 'absolute', top: 0 }}>
                                            <b className="me-2">ลายมือชื่อ</b>{eb.authorizer_name}
                                        </div>                                    
                                        <div style={{ position: 'absolute', bottom: 0 }}>
                                            <b className="me-2">วันที่</b>{util.convertDateToTextBE(eb.authorized_date)}
                                        </div>
                                    </td>
                                </tr>       

                                <tr>
                                    <td colSpan="3" style={{width: '40%', height: '120px', position: 'relative' }}>                                    
                                        <div style={{ position: 'absolute', top: 0 }}>
                                            <b>13. ข้อมูลสำหรับการกันเงินงบประมาณ</b>
                                        </div>
                                        <div style={{ position: 'absolute', bottom: 0 }}>
                                            เลขที่กันเงินงบประมาณ<br></br>
                                            <span className="underline-placeholder">{eb.budget_code}</span>
                                        </div>                                        
                                    </td>
                                    <td colSpan="5" style={{ width: '60%', position: 'relative' }}>
                                        <div style={{ position: 'absolute', top: 0 }}>
                                            <b className="me-2">ลายมือชื่อ</b>{eb.operator_name}
                                        </div>                                    
                                        <div style={{ position: 'absolute', bottom: 0 }}>
                                            <b className="me-2">วันที่</b>{util.convertDateToTextBE(eb.finance_date)}
                                        </div>
                                    </td>
                                </tr>                                                                                                                                                                                                                                 

                            </tbody>
                        </table>

                    </div>

            </div>
          </>
      </div>
      )
    )
  };
}

export default EB02PrintContent;